import * as tslib_1 from "tslib";
import { BaseService } from '../../_helpers';
import { HttpClient } from '@angular/common/http';
import { DictionaryEntity } from '../entity';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var MaintenanceCompanyDictionaryService = /** @class */ (function (_super) {
    tslib_1.__extends(MaintenanceCompanyDictionaryService, _super);
    function MaintenanceCompanyDictionaryService(http) {
        var _this = _super.call(this, 'config/maintenanceCompanies/idAndNames', DictionaryEntity) || this;
        _this.http = http;
        return _this;
    }
    MaintenanceCompanyDictionaryService.ngInjectableDef = i0.defineInjectable({ factory: function MaintenanceCompanyDictionaryService_Factory() { return new MaintenanceCompanyDictionaryService(i0.inject(i1.HttpClient)); }, token: MaintenanceCompanyDictionaryService, providedIn: "root" });
    return MaintenanceCompanyDictionaryService;
}(BaseService));
export { MaintenanceCompanyDictionaryService };
